export const HEADER_MIN_TRACKERS_COUNT_MESSAGE: number = 3;
